export default {
    name: 'Jobs'
}
